module.exports = __webpack_public_path__ + "img/Equuleus.d1c226f9.png";